import { observer } from 'mobx-react'
import { useQuery } from 'react-query'
import { useHistory } from 'react-router'
import AppContainer from '../../App/Container'
import { ReactComponent as ArrowLeft } from '../../assets/images/icons/arrow-left.svg'
import { ReactComponent as ChevronRightIcon } from '../../assets/images/icons/arrow-ios-right.svg'
import { Fragment, useEffect } from 'react'
import style from './InstructionPage.module.css'

const InstructionPage = observer(() => {
  const { push } = useHistory()
  const { data } = useQuery(
    'instruction-categories',
    async () => {
      const categories = await fetch(
        process.env.REACT_APP_STRAPI_URL +
          '/categories?_sort=id:ASC&_where[category_null]=false'
      ).then(async (res) => await res.json())

      return await Promise.all(
        categories.map(async (c) => {
          const articles = await fetch(
            process.env.REACT_APP_STRAPI_URL +
              '/articles?_where[category.slug]=' +
              c.slug
          ).then(async (res) => await res.json())
          return { ...c, articles }
        })
      )
    },
    {
      staleTime: 1_000_000
    }
  )

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="pb-10">
      <div
        className="bg-white py-7 px-12 flex items-center cursor-pointer"
        onClick={() => {
          push('/')
        }}
      >
        <ArrowLeft />
        <div className="ml-6">zurück zur Startseite</div>
      </div>
      <AppContainer>
        <h1 className={style.headline}>Anleitung</h1>
        <div className="grid grid-cols-3 gap-4">
          {(data || []).map((cat) => {
            return (
              <Fragment key={cat.id}>
                {cat.articles.length ? (
                  <div className="bg-white p-6 rounded shadow">
                    <h2 className="font-bold text-xl mb-4">{cat.title}</h2>
                    <div className="border-b">
                      {cat.articles.map((a) => {
                        return (
                          <div
                            key={a.id}
                            className="flex justify-between items-center border-t py-4 cursor-pointer"
                            onClick={() => {
                              push('/anleitung/' + a.slug)
                            }}
                          >
                            <h3>{a.title}</h3>
                            <ChevronRightIcon className="w-5 h-5 fill-current" />
                          </div>
                        )
                      })}
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </Fragment>
            )
          })}
        </div>
      </AppContainer>
    </div>
  )
})

export default InstructionPage
